/* PG PDP Hero ATF, "Bundle item" blocks: the other products of a multi-product bundle page.
   Each [data-hero-bundle-item] keeps its own option state (its pills never carry the hero's
   data-option-* attributes) and augment() appends the chosen variants to the hero's single
   /cart/add.js call. The bundle price comes from the store's bundle discount. */
(function () {
  if (window.PGHeroBundle) return;

  // "Right Hand" / "Right" / "right" all compare as "right".
  function handKey(value) {
    return String(value || '').trim().toLowerCase().split(/\s+/)[0];
  }

  // The hand currently chosen on the hero's own product (its option whose name contains "hand").
  function heroHand(section) {
    var groups = section.querySelectorAll('[data-option-index][data-option-name]');
    for (var i = 0; i < groups.length; i++) {
      if (/hand/i.test(groups[i].dataset.optionName)) {
        var btn = groups[i].querySelector('.pg-pdp-hero-atf__option--selected');
        return btn ? btn.dataset.optionValue : '';
      }
    }
    return '';
  }

  function setup(el) {
    if (el.__pgBundle) return el.__pgBundle;
    var section = el.closest('.pg-pdp-hero-atf');
    var count = parseInt(el.dataset.optionCount, 10) || 0;
    var variants = [];
    try { variants = JSON.parse(el.querySelector('[data-bundle-variants]').textContent); } catch (e) {}
    var buttons = el.querySelectorAll('button[data-bundle-option]');
    var followHand = el.querySelector('input[data-bundle-follow-hand]');

    var selected = [];
    el.querySelectorAll('input[data-bundle-option]').forEach(function (input) {
      selected[+input.dataset.bundleOption] = input.value;
    });
    buttons.forEach(function (b) {
      if (b.classList.contains('pg-pdp-hero-atf__option--selected')) selected[+b.dataset.bundleOption] = b.dataset.bundleValue;
    });

    function matches(v, opts) {
      for (var i = 0; i < count; i++) {
        if (v.options[i] !== opts[i]) return false;
      }
      return true;
    }

    function current() {
      for (var i = 0; i < variants.length; i++) {
        if (matches(variants[i], selected)) return variants[i];
      }
      return null;
    }

    function syncHand() {
      if (!followHand || !section) return;
      var key = handKey(heroHand(section));
      if (!key) return;
      var pos = +followHand.dataset.bundleOption;
      for (var i = 0; i < variants.length; i++) {
        if (handKey(variants[i].options[pos]) === key) {
          selected[pos] = variants[i].options[pos];
          followHand.value = selected[pos];
          return;
        }
      }
    }

    // Hide values with no variant for the current picks, strike through sold-out ones (same as the hero).
    function refresh() {
      buttons.forEach(function (b) {
        var test = selected.slice();
        test[+b.dataset.bundleOption] = b.dataset.bundleValue;
        var exists = variants.some(function (v) { return matches(v, test); });
        var available = variants.some(function (v) { return v.available && matches(v, test); });
        b.style.display = exists ? '' : 'none';
        b.classList.toggle('pg-pdp-hero-atf__option--unavailable', exists && !available);
      });
    }

    buttons.forEach(function (b) {
      b.addEventListener('click', function () {
        var pos = +b.dataset.bundleOption;
        selected[pos] = b.dataset.bundleValue;
        el.querySelectorAll('button[data-bundle-option="' + pos + '"]').forEach(function (s) {
          var on = s === b;
          s.classList.toggle('pg-pdp-hero-atf__option--selected', on);
          s.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        refresh();
      });
    });

    // The hero's own option buttons update their state in their click handler before this bubbles up.
    if (followHand && section) {
      section.addEventListener('click', function (e) {
        if (e.target.closest && e.target.closest('[data-option-position]')) {
          syncHand();
          refresh();
        }
      });
    }

    syncHand();
    refresh();

    el.__pgBundle = {
      current: current,
      label: el.dataset.label || 'This item',
      quantity: parseInt(el.dataset.quantity, 10) || 1
    };
    return el.__pgBundle;
  }

  function init(scope) {
    scope.querySelectorAll('[data-hero-bundle-item]').forEach(setup);
  }

  window.PGHeroBundle = {
    // items[0] is the hero's own line; every bundle line carries _pg_bundle = the page's template.
    augment: function (items, section) {
      var errorEl = section.querySelector('[data-hero-bundle-error]');
      if (errorEl) errorEl.hidden = true;
      var template = section.dataset.bundleTemplate || '';
      var out = items.slice();
      if (template && out[0]) {
        out[0] = Object.assign({}, out[0], { properties: Object.assign({}, out[0].properties || {}, { _pg_bundle: template }) });
      }
      section.querySelectorAll('[data-hero-bundle-item]').forEach(function (el) {
        var item = setup(el);
        var variant = item.current();
        if (!variant || !variant.available) {
          var error = new Error(variant
            ? item.label + ' is sold out in that option. Please choose another.'
            : 'Please choose your options for ' + item.label + '.');
          error.pgBundle = true;
          throw error;
        }
        var line = { id: variant.id, quantity: item.quantity };
        if (template) line.properties = { _pg_bundle: template };
        out.push(line);
      });
      return out;
    }
  };

  init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
